import * as actionTypes from "../ActionTypes/index";

const initialState = {
  loading: false,
  videos: [],
  error: null,
  success: false,
};

const teamVideoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_TEAM_VIDEO_REQUEST:
    case actionTypes.UPDATE_TEAM_VIDEO_REQUEST:
    case actionTypes.DELETE_TEAM_VIDEO_REQUEST:
    case actionTypes.READ_TEAM_VIDEO_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case actionTypes.SAVE_TEAM_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        videos: [...state.videos, action.payload],
      };

    case actionTypes.UPDATE_TEAM_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        videos: state.videos.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
      };

    case actionTypes.DELETE_TEAM_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        videos: state.videos.filter((item) => item._id !== action.payload._id),
      };

    case actionTypes.READ_TEAM_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        videos: action.payload,
      };

    case actionTypes.SAVE_TEAM_VIDEO_FAILURE:
    case actionTypes.UPDATE_TEAM_VIDEO_FAILURE:
    case actionTypes.DELETE_TEAM_VIDEO_FAILURE:
    case actionTypes.READ_TEAM_VIDEO_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    default:
      return state;
  }
};

export default teamVideoReducer;
